import React, { FC, useState } from 'react';

import { Stack, HStack, Text, Box } from '@chakra-ui/react';

import { HelpCount } from 'components/DataDisplay/Utils/HelpCount';
import { CopyIcon } from 'components/Icons';
import { renderCopyIcon } from 'containers/Setup/CloudAccounts/CloudAccountWizard/Components/OnboardGcp/utils';
import { CommandBox } from 'containers/Setup/CloudAccounts/CloudAccountWizard/Components/utils/CommandBox';

interface Props {
  subscriptionId: string;
}

export const CommandToEnableRemediation: FC<Props> = props => {
  const [copied, setCopied] = useState('');
  const command =
    `curl -sL https://sm-test-434.s3.us-east-1.amazonaws.com/azure_remediation_setup.sh | bash -s -- --scope ` +
    props.subscriptionId;

  return (
    <Stack px={2} spacing={6} h="full">
      <Stack spacing={3}>
        <HStack align={'start'}>
          <HelpCount count={1} />
          <HStack>
            <Text>Execute this script from Azure CLI</Text>
            <Box color="primary">
              {renderCopyIcon(
                {
                  copyText: command,
                  icon: <CopyIcon p={0.5} color="primary" />,
                  tooltip: 'Copy command',
                },
                copied,
                setCopied,
              )}
            </Box>
          </HStack>
        </HStack>
        <Box pl={8}>
          <CommandBox>{command}</CommandBox>
        </Box>
      </Stack>
    </Stack>
  );
};
